import { Users } from "lucide-react";
import { Layout, PageHeader } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { SpareSignup } from "@/components/SpareSignup";

export default function SpareList() {
  return (
    <Layout>
      <Seo
        title="Join the Spare List | Quinte BCA Pool League"
        description="Sign up for the Quinte BCA Pool League spare list to fill in on league nights. Add your name, phone and FargoRate so team captains can reach you when they need a spare."
        path="/spare-list"
      />
      <PageHeader
        eyebrow="Want to play?"
        title="Join the Spare List"
        subtitle="Add yourself to the spare list and team captains can call on you when they're short a player on league night. Sign up below — it only takes a minute."
      />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 text-center">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#E11D2A]/10 mb-5">
          <Users className="h-8 w-8 text-[#E11D2A]" />
        </div>
        <p className="text-[#555555] leading-relaxed mb-8">
          Spares must be sanctioned with the BCA before playing (a $30 annual sanctioning fee is paid your first night).
          This sign-up is for the current session. Your details are only shared with team captains when they need a spare.
        </p>
        <div className="flex justify-center" data-testid="spare-list-page-cta">
          <SpareSignup autoOpen />
        </div>
      </div>
    </Layout>
  );
}
